import { Link } from 'react-router-dom';
import type { TvShow } from '@/mocks/tvShows';

interface HeroBannerProps {
  featuredShows: TvShow[];
}

export default function HeroBanner({ featuredShows }: HeroBannerProps) {
  const mainShow = featuredShows[0];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="主推剧集">
      <img
        src={mainShow.cover}
        alt={mainShow.title}
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/40 via-background-950/20 to-background-50"></div>

      <div className="absolute inset-0 flex items-end pb-12 md:pb-20">
        <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
          <div className="flex flex-col md:flex-row items-start gap-6 md:gap-10">
            <div className="hidden md:block w-44 lg:w-56 flex-shrink-0 rounded-lg overflow-hidden shadow-2xl">
              <img
                src={mainShow.poster}
                alt={mainShow.title}
                className="w-full aspect-[3/4] object-cover object-top"
              />
            </div>
            <div className="flex-1 max-w-2xl">
              <div className="flex items-center gap-2 mb-2">
                <span className="bg-accent-500 text-background-950 text-xs px-2.5 py-1 rounded-md font-bold">
                  {mainShow.rating}
                </span>
                <span className="text-xs text-foreground-300 bg-background-950/40 px-2 py-1 rounded-md">
                  {mainShow.category}
                </span>
                <span className="text-xs text-foreground-300 bg-background-950/40 px-2 py-1 rounded-md">
                  {mainShow.year}
                </span>
              </div>
              <h1 className="text-2xl md:text-5xl font-bold text-foreground-50 font-heading mb-2">
                {mainShow.title}
              </h1>
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed line-clamp-3 mb-4">
                {mainShow.description}
              </p>
              <p className="text-xs md:text-sm text-foreground-400 mb-5">
                {mainShow.updateInfo} · {mainShow.genres.join(' / ')}
              </p>
              <div className="flex items-center gap-3">
                <Link
                  to={`/detail/${mainShow.id}`}
                  className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-foreground-50 px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-play-fill text-base"></i>
                  </div>
                  立即观看
                </Link>
                <span className="text-xs text-foreground-400">
                  播放量 {mainShow.views}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {featuredShows.slice(0, 5).map((show, idx) => (
          <button
            key={show.id}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              idx === 0
                ? 'bg-accent-500 w-6'
                : 'bg-foreground-400/50 hover:bg-foreground-300'
            }`}
            aria-label={`切换到${show.title}`}
          />
        ))}
      </div>
    </section>
  );
}